module.exports = __webpack_public_path__ + "3d5cb5bb467f32a2ac2370fac88fcd0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2129_teaser_image.jpg
// module id = 609
// module chunks = 0